import React from 'react';
import { Box, Paper, Toolbar, Typography, TextField, MenuItem, Button } from '@mui/material';
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { fetchShiftsMonitor, AdminShiftRow } from '../api/scheduling.ts';

const columns: GridColDef[] = [
  { field: 'tenantName', headerName: 'Tenant', flex: 1 },
  { field: 'userName', headerName: 'Employee', flex: 1 },
  { field: 'roleKey', headerName: 'Role', width: 140 },
  { field: 'startTime', headerName: 'Start', width: 180 },
  { field: 'endTime', headerName: 'End', width: 180 },
  { field: 'status', headerName: 'Status', width: 120 },
];

const roles = ['WAITER','RECEPTION','HK','CHEF'];

export default function ShiftsMonitor(){
  const [rows, setRows] = React.useState<AdminShiftRow[]>([]);
  const [total, setTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [tenantId, setTenantId] = React.useState<number | ''>('' as any);
  const [date, setDate] = React.useState<string>(new Date().toISOString().slice(0,10));
  const [role, setRole] = React.useState<string>('');
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(20);

  const load = async () => {
    setLoading(true);
    const resp = await fetchShiftsMonitor({ tenantId: tenantId ? Number(tenantId) : undefined, date, role: role || undefined, page, size: pageSize });
    setRows(resp.content || []);
    setTotal(Number(resp.totalElements || 0));
    setLoading(false);
  };

  React.useEffect(()=> { load(); /* eslint-disable-next-line */ }, [tenantId, date, role, page, pageSize]);

  const handlePaginate = (model: GridPaginationModel) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  return (
    <Box p={2}>
      <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
        <Toolbar disableGutters sx={{ gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="h6" sx={{ flex: 1 }}>Shifts Monitor</Typography>
          <TextField label="Tenant ID" size="small" value={tenantId} onChange={(e)=> setTenantId((e.target.value as any))} sx={{ width: 160 }} />
          <TextField label="Date" type="date" size="small" value={date} onChange={(e)=> setDate(e.target.value)} sx={{ width: 160 }} InputLabelProps={{ shrink: true }} />
          <TextField select label="Role" size="small" value={role} onChange={(e)=> setRole(e.target.value)} sx={{ width: 160 }}>
            <MenuItem value="">All</MenuItem>
            {roles.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
          </TextField>
          <Button variant="outlined" onClick={()=> { setPage(0); load(); }}>Refresh</Button>
        </Toolbar>
      </Paper>

      <Paper elevation={0}>
        <div style={{ height: 560, width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowCount={total}
            loading={loading}
            pageSizeOptions={[10,20,50]}
            paginationMode="server"
            paginationModel={{ page, pageSize }}
            onPaginationModelChange={handlePaginate}
            disableRowSelectionOnClick
            getRowId={(r)=> r.id}
          />
        </div>
      </Paper>
    </Box>
  );
}


